"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LearningTableBodyDescriptionCell = void 0;
var app_1 = require("app");
var React = require("react");
var String_utils_1 = require("src/String.utils");
var LearningTableBodyDescriptionCell = function (_a) {
    var cellInfo = _a.cellInfo, buttonLabel = _a.buttonLabel, isMobile = _a.isMobile, isInvisible = _a.isInvisible, columnQuantity = _a.columnQuantity, isEmpty = _a.isEmpty;
    var courseUrl = cellInfo.url || '';
    var description = React.useMemo(function () {
        if (!cellInfo.description)
            return React.createElement("div", null, "-");
        return cellInfo.description && (0, app_1.StringToHTML)((0, String_utils_1.processCourseDescription)(cellInfo.description));
    }, [cellInfo.description]);
    var colSpanQuantity = columnQuantity && isEmpty ? columnQuantity : 4;
    return (React.createElement("td", { colSpan: colSpanQuantity },
        React.createElement("div", { className: "table--nested table w-full" },
            React.createElement("div", { className: "learning-table-body-description-wrapper table--nested-row grid gap-6 downtotablet:grid-cols-[3fr_1fr]" },
                React.createElement("div", { className: "table--nested-cell left-cell table-cell" },
                    React.createElement("div", { className: "learning-table-body-description whitespace-pre-line [overflow-wrap:anywhere]" }, description)),
                React.createElement("div", { className: "table--nested-cell right-cell text-right justify-self-start downtotablet:justify-self-end downtotablet:self-center" },
                    React.createElement("div", { className: "learning-component_cta" },
                        React.createElement("a", { href: courseUrl, className: "cta ".concat(isMobile ? 'cta--small' : 'cta--large', " cta--alpha enroll-button btn-primary btn-large"), target: "_blank", rel: "noreferrer", tabIndex: isInvisible ? -1 : 0 },
                            React.createElement("span", { className: "cta-content" },
                                React.createElement("span", { className: "cta-content-text" }, buttonLabel)))))))));
};
exports.LearningTableBodyDescriptionCell = LearningTableBodyDescriptionCell;
